import React from "react";
// import img5 from "../../assets/images/blog/blog-img7.jpg";
// import img6 from "../../assets/images/blog/blog-img8.jpg";
// import img7 from "../../assets/images/blog/blog-img9.jpg";
import { Link } from "@reach/router";
import { fontsName } from "../../assets/fonts/fontsName";
import { fixNumbers } from "../fixNumbers";
// import { request, gql } from "graphql-request";
import { GraphQLClient, gql } from "graphql-request";
import { REQUEST_URL } from "../RequestUrl";
import { Button } from "@material-ui/core";
var moment = require("moment-timezone");
moment().tz("Asia/Tehran").format();
moment.tz.setDefault("Asia/Tehran");
var moment2 = require("moment-jalaali");

const GET_POSTS = gql`
  query GetNewsByRangeForWebsite($range: Int) {
    getNewsByRangeForWebsite(range: $range) {
      _id
      titel
      description
      link
      date
      school_name
      newsType
      newsStatus
      personId {
        _id
        person_id
        person_name
        person_surname
        person_password
        person_national_id
        YearofBirth
        person_phone_number
        person_fatherName
        motherPhoneNumber
        fatherPhoneNumber
        level
        class_name
        school_name
        person_role
        photoURL
      }
    }
  }
`;

const NewNews = () => {
  const [postsList, setPostsList] = React.useState([]);
  const [postDate, setPostDate] = React.useState([]);
  const [rangeValue, setRangeValue] = React.useState(6);
  const client = new GraphQLClient(REQUEST_URL);

  var epochDate = "";
  var dateList = [];

  const variables = {
    range: rangeValue,
  };

  React.useEffect(() => {
    // request(REQUEST_URL, variables, GET_POSTS).then((data) => {
    //   console.log("posts:", data);
    //   setPostsList(data.getNewsByRangeForWebsite);
    //   for (let i = 0; i < data.getNewsByRangeForWebsite.length; i++) {
    //     epochDate = new Date(
    //       Number(data.getNewsByRangeForWebsite[i].date) * 1000
    //     );
    //     dateList.push(epochDate);
    //     epochDate = "";
    //   }
    //   if (dateList.length > 0) {
    //     var temp = [...postDate];
    //     for (let i = 0; i < dateList.length; i++) {
    //       temp[i] = fixNumbers(moment2(dateList[i]).format("jYYYY/jMM/jDD"));
    //     }
    //     if (temp.length) setPostDate(temp);
    //   }
    // });
    client.request(GET_POSTS, variables).then((data) => {
      setPostsList(data.getNewsByRangeForWebsite);
      for (let i = 0; i < data.getNewsByRangeForWebsite.length; i++) {
        epochDate = new Date(
          Number(data.getNewsByRangeForWebsite[i].date) * 1000
        );
        dateList.push(epochDate);
        epochDate = "";
      }
      if (dateList.length > 0) {
        var temp = [...postDate];
        for (let i = 0; i < dateList.length; i++) {
          temp[i] = fixNumbers(moment2(dateList[i]).format("jYYYY/jMM/jDD"));
        }
        if (temp.length) setPostDate(temp);
      }
    });
  }, []);

  React.useEffect(() => {
    // if (isLoadMore) {
    let variables = {
      range: rangeValue,
    };
    client.request(GET_POSTS, variables).then((data) => {
      setPostsList(data.getNewsByRangeForWebsite);
      for (let i = 0; i < data.getNewsByRangeForWebsite.length; i++) {
        epochDate = new Date(
          Number(data.getNewsByRangeForWebsite[i].date) * 1000
        );
        dateList.push(epochDate);
        epochDate = "";
      }
      if (dateList.length > 0) {
        var temp = [...postDate];
        for (let i = 0; i < dateList.length; i++) {
          temp[i] = fixNumbers(moment2(dateList[i]).format("jYYYY/jMM/jDD"));
        }
        if (temp.length) setPostDate(temp);
      }
      // setIsLoadMore(false);
    });
    // }
  }, [rangeValue]);

  const handleLoadMore = () => {
    setPostsList([]);
    dateList = [];
    setRangeValue((prev) => prev + 6);
  };

  return (
    <div className="subscribe-area ptb-100">
      <div className="container" dir="rtl">
        <div className="row align-items-center">
          {postsList && postsList.length > 0
            ? postsList.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                <div className="single-blog-post bg-fffbf5">
                  <div className="post-image">
                    <Link
                      to={`/site/news-details/?id=${item._id}`}
                      state={{
                        linkPost: item.link[0],
                        titlePost: item.titel,
                        descriptionPost: item.description,
                        typePost: item.newsType,
                      }}
                    >
                      {item.newsType == "withPhoto" ? (
                        <img src={item.link[0]} alt="news" />
                      ) : (
                        <video
                          className="video-blog"
                          style={{ height: "350px", width: "100%" }}
                          controls
                        >
                          <source src={item.link[0]} type="video/mp4" />
                        </video>
                      )}
                    </Link>
                  </div>

                  <div
                    className="post-content"
                    style={{
                      direction: "rtl",
                      fontFamily: fontsName.Vazir,
                    }}
                  >
                    <ul className="post-meta d-flex justify-content-between align-items-center">
                      <li>
                        <div className="post-author d-flex align-items-center">
                          <span>
                            {item.personId.person_name +
                              " " +
                              item.personId.person_surname}
                          </span>
                        </div>
                      </li>
                      <li>
                        <i className="flaticon-calendar"></i>{" "}
                        {postDate[index]}
                      </li>
                    </ul>
                    <h3
                      style={{
                        direction: "rtl",
                        fontFamily: fontsName.Vazir,
                        textAlign: "right",
                      }}
                    >
                      <Link
                        to={`/site/news-details/?id=${item._id}`}
                        state={{
                          linkPost: item.link[0],
                          titlePost: item.titel,
                          descriptionPost: item.description,
                          typePost: item.newsType,
                        }}
                      >
                        {item.titel}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            ))
            : ""}

          {/* <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img6} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.Vazir,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img7} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.Vazir,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img5} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.Vazir,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img6} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.Vazir,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img7} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.Vazir,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div> */}
        </div>
        <div style={{ width: "100%", textAlign: "center", marginTop: "12px" }}>
          <Button
            variant="outlined"
            color="primary"
            style={{
              padding: "3px 30px",
              borderRadius: "20px",
              fontSize: "16px",
              fontFamily: fontsName.VazirBold,
            }}
            onClick={handleLoadMore}
          >
            نمایش بیشتر
          </Button>
        </div>
      </div>

      {/* <div className="vector-shape6">
        <img src={shape6} alt="shape" />
      </div> */}
    </div>
  );
};

export default NewNews;
